import { faGear, faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import PageTabs from '@/components/shared/PageTabs';
import { useTranslator } from '@/hooks/useTranslator';
import { useSessionStore } from '@/store/sessionStore';
import { ProfileHeader } from '../-components/ProfileHeader';

export const Route = createFileRoute('/(client)/profile/(pages)')({
  beforeLoad: ({ location }) => {
    // Backwards-compat: ?tab=settings → /profile/settings (safe to remove after a release).
    const tab = new URLSearchParams(location.searchStr).get('tab');
    if (tab === 'settings') {
      throw redirect({ to: '/profile/settings' });
    }
    // /profile (no child) → default to overview
    if (location.pathname === '/profile' || location.pathname === '/profile/') {
      throw redirect({ to: '/profile/overview' });
    }
  },
  component: ProfileLayout,
});

function ProfileLayout() {
  const { getTranslation: t } = useTranslator({ page: 'profile' });
  const { getTranslation: tShared } = useTranslator({ page: 'shared' });
  const user = useSessionStore(s => s.user);

  if (!user) return null;

  const tabs = [
    {
      key: 'overview',
      label: t('tabs.overview'),
      icon: <FontAwesomeIcon icon={faUser} />,
      to: '/profile/overview',
    },
    {
      key: 'settings',
      label: t('tabs.settings'),
      icon: <FontAwesomeIcon icon={faGear} />,
      to: '/profile/settings',
    },
  ];

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-y-auto'>
      <ProfileHeader user={user} />
      <div className='sticky top-0 z-20 bg-background'>
        <PageTabs tabs={tabs} mode='path' moreLabel={tShared('moreTabs')} />
      </div>
      <Outlet />
    </div>
  );
}
